// Code review - In Progress
// Documentation - In Progress
import { useEffect, useState } from "react";
import { mainTable } from "../css/Common";
import MainLayout from "../components/MainLayout";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import MainPopup from "../popup-containers/MainPopup";
import "react-toastify/dist/ReactToastify.css";
import PartnerOrganizationPopup from "../popup-containers/PartnerOrganizationPopup";
import { PartnerOrganizationHeader } from "../components/HeaderAttribute";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import toast from "react-hot-toast";
import GridPage from "../components/GridPage";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import Buttons from "../components/Buttons";
import { useLocation } from "react-router-dom";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import Loader from "../ReusableComponents/Loader";
import { useUserCapability } from "../components/ConstantReducerProvider";
import * as XLSX from "sheetjs-style";
const PartnerOrganization = () => {
  const location1 = useLocation();
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);

  const [popUpOpen, setpopUpOpen] = useState(false);
  const [rowIndex, setRowIndex] = useState("");
  const [partnerData, setPartnerData] = useState("");
  const [popupdata1, setPopupdata1] = useState({});
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [updateScreen, setUpdateScreen] = useState(false);
  const [addScreen, setAddScreen] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const createdBy = sessionStorage.getItem("createdBy");
  const [mstPartnerOrganizationId, setMstPartnerOrganizationId] = useState("");

  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [location, setLocation] = useState("");
  const [partnerorganization, setPartnerOrganization] = useState("");
  const [stateError, setStateError] = useState("");
  const [locationError, setLocationError] = useState("");
  const [partnerorganizationError, setPartnerOrganizationError] = useState("");

  const [bindCountriesDD, setBindCountriesDD] = useState([]);
  const [bindStateDropDown, setBindStateDropDown] = useState([]);

  const [editMode, setEditMode] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);

  const [bindLocation, setBindLocationDD] = useState([]);
  const [getLocationDatas, setGetLocationDatas] = useState([]);

  const [isOpen, setIsOpen] = useState(false);

  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;

  useEffect(() => {
    const stateSelectedValue = getLocationDatas.find(
      (item) => item.MstStateId == state.value
    );

    if (stateSelectedValue) {
      const locationLabels = getLocationDatas
        .filter((item) => item.MstStateId === stateSelectedValue.MstStateId)
        .map((item) => ({
          MstLocationId: item.MstLocationId,
          LocationName_en: item.LocationName_en,
        }));

      const locationSelected = locationLabels.map((LC) => ({
        value: LC.MstLocationId,
        label: LC.LocationName_en,
      }));
      setBindLocationDD(locationSelected);
    } else {
      console.log("stateSelectedValue is undefined or not found.");
    }
  }, [state]);

  const [bindPartnerOrganizationDatas, setBindPartnerOrganizationDatas] =
    useState([]);

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreen(true);
    setUpdateScreen(false);
  };

  const filterBlocked = (data) => (data || []).filter((item) => item.BlockedBy === null);

  useEffect(() => {

    PartnerOrganizationData();
  }, []);
  const PartnerOrganizationData = async () => {
    try {
      setIsLoading(true);
      const data = {
        mstOrganizationStructureId: userProfileDatas[0]?.MstOrganizationId,
        mstBranchId: userProfileDatas[0]?.MstLocationId,
        mstSdpId: userProfileDatas[0].MstSDPId
          ? userProfileDatas[0].MstSDPId
          : 0,
        mstUserId: userProfileDatas[0]?.MstUserId,
        mstRoleId: userProfileDatas[0]?.MstRoleId,
      };

      const [locationRes, statesRes, partnerRes] = await Promise.all([
        BindAPI("LocationAPI/GetLocation"),
        BindAPI("StateAPI/GetState"),
        BindPostAPI(data, "PartnerOrganizationAPI/BindPartnerOrganization"),
      ]);

      // ✅ Location
      setGetLocationDatas(filterBlocked(locationRes?.data?.Table));

      // ✅ States
      const statesData = filterBlocked(statesRes?.data?.Table).map((item) => ({
        value: item.MstStateId,
        label: item.StateName_en,
      }));
      setBindStateDropDown(statesData);

      // ✅ Partner Organization
      setBindPartnerOrganizationDatas(partnerRes?.data?.Table || []);
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const cancel = () => {
    setEditMode(false);
    setSelectedRowIndex(null);
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setSubmitBtnDisabled(false);
    clearData();
    PartnerOrganizationData();
    setIsLoading(false);
  };

  const clearData = () => {
    setState("");
    setLocation("");
    setPartnerOrganization("");
    setStateError("");
    setLocationError("");
    setPartnerOrganizationError("");
  };

  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    setIsLoading(true);
    if (flag == 1 || flag == 2) {
      // validation start
      let stateValidate = "";
      let locationValidate = "";
      let partnerOrganizationValidate = "";

      stateValidate = state ? "" : "Select a State";
      setStateError(stateValidate);

      locationValidate = location ? "" : "Select a Branch/Project";
      setLocationError(locationValidate);

      partnerOrganizationValidate =
        partnerorganization.length > 0
          ? /^[A-Za-z0-9 !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(
            partnerorganization
          )
            ? ""
            : "Only Alphabet, Numbers and space allowed"
          : "Enter Partner Organization";
      setPartnerOrganizationError(partnerOrganizationValidate);

      if (stateValidate || locationValidate || partnerOrganizationValidate) {
        setIsOpen(true);
      }

      if (!stateValidate && !locationValidate && !partnerOrganizationValidate) {
        setIsOpen(false);
        const data = [
          {
            mstPartnerOrganizationId: mstPartnerOrganizationId
              ? mstPartnerOrganizationId
              : 0,
            mstCountryId: 1,
            mstStateId: state.value,
            mstLocationId: location.value,
            partnerOrganizationName: partnerorganization,
            createdby: createdBy,
            flag: flag,
          },
        ];
        const response = await IUDAPI(
          data,
          "PartnerOrganizationAPI/IUDPartnerOrganization"
        );
        if (flag == 1) {
          // Submit
          if (response.data.Table[0].Result === "S") {
            toast.success("Partner Organization data added successfully 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to add Partner Organization data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        } else if (flag == 2) {
          // Update
          if (response.data.Table[0].Result === "M") {
            toast.success("Partner Organization data updated successfully 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to update Partner Organization data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        }
      } else {
        setSubmitBtnDisabled(false);
        setIsLoading(false);
      }
    } else {
      const data = [
        {
          mstPartnerOrganizationId:
            bindPartnerOrganizationDatas[rowIndex].MstPartnerOrganizationId,
          createdby: createdBy,
          flag: flag,
        },
      ];
      const response = await IUDAPI(
        data,
        "PartnerOrganizationAPI/IUDPartnerOrganization"
      );
      if (flag == 3) {
        // Delete
        if (response.data.Table[0].Result === "D") {
          toast.success("Partner Organization data deleted successfully 👍", {
            duration: 5000,
            position: "top-center",
          });
          setTimeout(cancel, 5000);
        } else {
          toast.error("Failed to delete Partner Organization data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      } else if (flag == 4) {
        // Block
        if (response.data.Table[0].Result === "B") {
          toast.success("Partner Organization data blocked successfully 👍", {
            duration: 5000,
            position: "top-center",
          });
          setTimeout(cancel, 5000);
        } else {
          toast.error("Failed to block Partner Organization data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      } else if (flag == 5) {
        // Unblock
        if (response.data.Table[0].Result === "UB") {
          toast.success("Partner Organization data unblocked successfully 👍", {
            duration: 5000,
            position: "top-center",
          });
          setTimeout(cancel, 5000);
        } else {
          toast.error("Failed to unblock Partner Organization data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      }
    }
  };

  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };

  const handlePartnerOrganization = (rowIndex, flag) => {
    handleOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }
    setPartnerData(bindPartnerOrganizationDatas[rowIndex]);

    const StaterowData = bindPartnerOrganizationDatas[rowIndex];
    const StateInfo = bindStateDropDown.find(
      (ST) => ST.value === StaterowData.MstStateId
    );

    const resultState = {
      value: StaterowData.MstStateId,
      label: StateInfo ? StateInfo.label : "DefaultStateLabel",
    };

    const locationrowData = bindPartnerOrganizationDatas[rowIndex];
    const LocationInfo = getLocationDatas.find(
      (L) => L.MstLocationId === locationrowData.MstLocationId
    );
    const ResultLocation = {
      value: locationrowData.MstLocationId,
      label: LocationInfo ? LocationInfo.LocationName_en : "DefaultStateLabel",
    };

    const AutoDropdownPopupdata = [resultState, ResultLocation];
    setPopupdata1(AutoDropdownPopupdata);
  };

  const dropdownValuesEffect = () => {
    if (editMode && selectedRowIndex !== null) {
      dropdownstate(selectedRowIndex);
      dropdownlocation(selectedRowIndex);
    }
  };

  const dropdownstate = (rowIndex) => {
    try {
      const StaterowData = bindPartnerOrganizationDatas[rowIndex];
      const StateInfo = bindStateDropDown.find(
        (ST) => ST.value === StaterowData.MstStateId
      );

      const resultState = {
        value: StaterowData.MstStateId,
        label: StateInfo ? StateInfo.label : "DefaultStateLabel",
      };

      setState(resultState);
    } catch (error) {
      console.error("Error setting state:", error);
    }
  };

  const PartnerOrganizationHeaderExcel = [
    { title: "S.No" },
    { title: "MstPartnerOrganizationId" },
    { title: "Country" },
    { title: "State" },
    { title: "Branch/Project" },
    { title: "Partner Organization" },
    { title: "Created by" },
  ];

  const handleExport = async () => {
    const createdBy = sessionStorage.getItem("createdBy");
    const userProfileDatas = userProfileState?.userProfile || [];
    const userId = parseInt(createdBy || "0", 10);
  
    try {
      // payload for API
      const data = {
        mstOrganizationStructureId: userProfileDatas[0]?.MstOrganizationId,
        mstBranchId: userProfileDatas[0]?.MstLocationId,
        mstSdpId: userProfileDatas[0]?.MstSDPId || 0,
        mstUserId: userProfileDatas[0]?.MstUserId,
        mstRoleId: userProfileDatas[0]?.MstRoleId,
      };
  
      const response = await BindPostAPI(
        data,
        "PartnerOrganizationAPI/BindPartnerOrganizationExcel"
      );
  
      const rows = response?.data?.Table || [];
  
      // ❌ NO DATA CASE
      if (rows.length === 0) {
        await IUDAPI(
          {
            mstUserId: userId,
            sp: "PARTNER ORGANIZATION",
            action: "EXCEL EXPORT",
            status: "FAILED",
            tableName: "mst_partner_organization",
            description: "No data available to export",
          },
          "Log/IUDLog"
        );
  
        toast.error("No data available to export", {
          duration: 1000,
          position: "top-center",
        });
  
        return;
      }
  
      // ✅ SUCCESS LOG
      await IUDAPI(
        {
          mstUserId: userId,
          sp: "PARTNER ORGANIZATION",
          action: "EXCEL EXPORT",
          status: "SUCCESS",
          tableName: "mst_partner_organization",
          description: `Total Records: ${rows.length}`,
        },
        "Log/IUDLog"
      );
  
      // ✅ EXPORT
      exportPartnerOrganizationData(
        PartnerOrganizationHeaderExcel.map((col) => col.title),
        rows
      );
  
    } catch (error) {
      console.error("Partner Organization Excel Export Error:", error);
  
      const userId = parseInt(sessionStorage.getItem("createdBy") || "0", 10);
  
      await IUDAPI(
        {
          mstUserId: userId,
          sp: "PARTNER ORGANIZATION",
          action: "EXCEL EXPORT",
          status: "FAILED",
          tableName: "mst_partner_organization",
          description: error?.message || "Excel export failed",
        },
        "Log/IUDLog"
      );
  
      toast.error("Failed to export Partner Organization data", {
        duration: 1000,
        position: "top-center",
      });
    }
  };

  const exportPartnerOrganizationData = (columns, rows) => {
    /* ================= TITLE ================= */
    const titleRow = [
      {
        v: "Partner Organization Master",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    /* ================= HEADER ================= */
    const headerRow = columns.map((column) => ({
      v: column,
      s: {
        fill: { fgColor: { rgb: "2D2D6E" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left" },
      },
    }));

    const spacingRow = [{ v: "" }];

    /* ================= DATA ROWS ================= */
    const dataRows = rows.map((row, index) => {
      const isAlt = index % 2 === 1;
      const style = isAlt ? { fill: { fgColor: { rgb: "F0F0F0" } } } : {};

      return [
        { v: index + 1, s: style },
        { v: row.MstPartnerOrganizationId, s: style },          // Country
        { v: row.CountryName_en, s: style },          // Country
        { v: row.StateName_en, s: style },            // State
        { v: row.LocationName_en, s: style },         // Branch/Project
        { v: row.PartnerOrganizationName, s: style },
        { v: row.CreatedByName, s: style },
        // { v: row.IsBlocked === 1 ? "Yes" : "No", s: style }, // Optional
      ];
    });

    /* ================= SHEET DATA ================= */
    const wsData = [
      titleRow,
      spacingRow,
      headerRow,
      ...dataRows,
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    /* ================= COLUMN WIDTH ================= */
    ws["!cols"] = [
      { width: 5 },   // S.No
      { width: 25 },  // State
      { width: 25 },  // State
      { width: 30 },  // Branch/Project
      { width: 35 },  // Partner Organization
      { width: 30 },  // Created By
      { width: 35 }, // Blocked
    ];

    /* ================= ROW HEIGHT ================= */
    ws["!rows"] = [
      { hpt: 30 },
      { hpt: 15 },
      { hpt: 18 },
      ...Array(rows.length).fill({ hpt: 15 }),
    ];

    /* ================= BORDERS ================= */
    const applyStyles = (worksheet) => {
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!worksheet[cellRef]) continue;

          worksheet[cellRef].s = {
            ...worksheet[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    /* ================= EXPORT ================= */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Partner Organization Master");
    XLSX.writeFile(wb, "Partner_Organization_Master.xlsx");

    toast.success("Excel exported successfully 👍", {
      duration: 1000,
      position: "top-center",
    });
  };

  const dropdownlocation = (rowIndex) => {
    try {
      const locationrowData = bindPartnerOrganizationDatas[rowIndex];
      const LocationInfo = getLocationDatas.find(
        (L) => L.MstLocationId === locationrowData.MstLocationId
      );
      const ResultLocation = {
        value: locationrowData.MstLocationId,
        label: LocationInfo
          ? LocationInfo.LocationName_en
          : "DefaultStateLabel",
      };
      setLocation(ResultLocation);
    } catch (error) {
      console.error("Error setting state:", error);
    }
  };

  useEffect(dropdownValuesEffect, [editMode, selectedRowIndex]);
  const handleEdit = (rowIndex) => {
    setEditMode(true);
    setSelectedRowIndex(rowIndex);

    setUpdateScreen(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreen(false);

    setPartnerOrganization(
      bindPartnerOrganizationDatas[rowIndex].PartnerOrganizationName
    );

    setMstPartnerOrganizationId(
      bindPartnerOrganizationDatas[rowIndex].MstPartnerOrganizationId
    );
    setState(bindPartnerOrganizationDatas[rowIndex].MstStateId);
    setLocation(bindPartnerOrganizationDatas[rowIndex].MstLocationId);
  };
  useEffect(() => {
    if (location1.pathname == "/partnerorganization") {
      setVisibleTable(true);
      setVisibleAdd(false);
      PartnerOrganizationData();
    }
  }, [location1]);
  return (
    <MainLayout pageName="2">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title={`Partner Organization Master`}
          header={PartnerOrganizationHeader}
          records={bindPartnerOrganizationDatas}
          handleEdit={handleEdit}
          handleExportBtn={true}
          handleExport={handleExport}
          handleAction={handlePartnerOrganization}
          showAdd={showAdd}
          blockView={true}
        />
      )}
      {visibleAdd && (
        <div class="w-full ">
          <div class=" border-black  ">
            <div class="text-black text-2xl font-bold my-2">
              {addScreen && (
                <div class={mainTable.addScreenTitle}>
                  {"Partner Organization Master - Add"}
                </div>
              )}

              {updateScreen && (
                <div class={mainTable.addScreenTitle}>
                  {"Partner Organization Master - Edit"}
                </div>
              )}
            </div>
          </div>
          <div class="mx-auto  md:w-2/5 w-full border-black">
            <div class="relative w-full h-full max-w-xl md:h-auto">
              <div class="relative bg-white rounded-lg shadow ">
                <div class="px-6 py-6 lg:px-8">
                  <form class="space-y-6" action="#">
                    <AutoDropDown
                      classStar="text-red-500"
                      classDiv="hidden"
                      title={"Country"}
                      options={bindCountriesDD}
                      selectedOption={country}
                      placeholder={"Select"}
                      name={"country"}
                      controlFunc={(value) => {
                        setCountry(value);
                      }}
                      Class="custom-class"
                      disabled="false"
                      tabIndex="1"
                    />
                    <div>
                      <AutoDropDown
                        classStar="text-red-500"
                        title="State"
                        options={bindStateDropDown}
                        placeholder="Select"
                        name="state"
                        selectedOption={state}
                        Class="custom-class"
                        tabIndex="1"
                        controlFunc={(value) => {
                          setState(value);
                          setStateError(value ? "" : "Select a State");
                          setLocation("");
                        }}
                        controlFuncBlur={() => {
                          setStateError(state ? "" : "Select a State");
                        }}
                      />
                      {stateError && (
                        <span className="text-red-500">{stateError}</span>
                      )}
                    </div>
                    <div>
                      <AutoDropDown
                        classStar="text-red-500"
                        title="Branch/Project"
                        options={bindLocation}
                        placeholder="Select"
                        name="state"
                        selectedOption={location}
                        Class="custom-class"
                        tabIndex="1"
                        controlFunc={(value) => {
                          setLocation(value);
                          setLocationError(
                            value ? "" : "Select a Branch/Project"
                          );
                        }}
                        controlFuncBlur={() => {
                          setLocationError(
                            location ? "" : "Select a Branch/Project"
                          );
                        }}
                      />
                      {locationError && (
                        <span className="text-red-500">{locationError}</span>
                      )}
                    </div>

                    <InputText
                      classStar="text-red-500"
                      inputType={"text"}
                      title={"Partner Organization"}
                      name={"partnerorganization"}
                      content={partnerorganization}
                      maxLength={100}
                      controlFunc={(e) => {
                        // setPartnerOrganization(e.target.value)
                        const value = e.target.value;
                        setPartnerOrganization(value);
                        setPartnerOrganizationError(
                          value.length > 0
                            ? /^[\S]+(?:\s[\S]+)*$/.test(value)
                              ? "" // No error if the input is valid
                              : ""
                            : "Enter Partner Organization" // Error message if the input is empty
                        );
                      }}
                      controlFuncBlur={(e) => {
                        const trimmedValue = e.target.value.trim();
                        setPartnerOrganization(trimmedValue);
                        setPartnerOrganizationError(
                          trimmedValue.length > 0
                            ? /^[\S]+(?:\s[\S]+)*$/.test(trimmedValue)
                              ? "" // No error if the input is valid
                              : "Only single spaces between words allowed"
                            : "Enter Partner Organization" // Error message if the input is empty
                        );
                      }}
                    />
                    {partnerorganizationError && (
                      <span class="text-red-500">
                        {partnerorganizationError}
                      </span>
                    )}
                  </form>
                  <Buttons
                    addScreenTitle={addScreen}
                    updateScreenTitle={updateScreen}
                    handleSubmit={handleSubmit}
                    cancel={cancel}
                    disabledBtn={submitBtnDisabled ? true : false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handlePartnerOrganization}
      >
        <div>
          <PopUpScreenTitle
            title="Partner Organization Master"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />

          <PartnerOrganizationPopup data={partnerData} data1={popupdata1} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default PartnerOrganization;
